import { INearbyResort } from 'api/region/types';
import classNames from 'classnames';
import Link from 'next/link';
import { SwiperSlide, Swiper } from 'swiper/react';
import 'swiper/css';
import SwiperCore, { Navigation } from 'swiper';
import { Routes } from 'routes';
import { ImageComponent } from 'components/common/ImageComponent';
import { ReactComponent as SvgArrowWhiteBg } from 'public/assets/icons/arrow-white-bg.svg';
import { useRef, useCallback } from 'react';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import styles from './styles.module.scss';
import { SectionHeader } from '../SectionHeader';

SwiperCore.use([Navigation]);

const swiperBreakpoints = {
  320: {
    slidesPerView: 1,
  },
  576: {
    slidesPerView: 1.925,
  },
  762: {
    slidesPerView: 2,
  },
  1200: {
    slidesPerView: 3,
  },
};

interface Props {
  nearbyResorts: INearbyResort[];
}

export const NearbyResortsSection = ({ nearbyResorts }:Props) => {
  const sliderRef = useRef<SwiperCore | null>(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const { t } = useOTSTranslation('common');

  const shouldShowNavigation = nearbyResorts.length > 3;

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.slideNext();
  }, []);

  return (
    <section id={styles.nearbyResorts}>
      <SectionHeader title={t('common.nearbyResorts')} />
      {shouldShowNavigation && (
      <>
        <button
          type="button"
          ref={prevRef}
          className={classNames(styles.swiperNavButton, styles.swiperButtonPrev)}
          onClick={() => handlePrev()}
        >
          <SvgArrowWhiteBg />
        </button>

        <button
          type="button"
          ref={nextRef}
          className={classNames(styles.swiperNavButton, styles.swiperButtonNext)}
          onClick={() => handleNext()}
        >
          <SvgArrowWhiteBg />
        </button>
      </>
      )}
      <Swiper
        slidesPerView="auto"
        breakpoints={swiperBreakpoints}
        spaceBetween={16}
        className={styles.swiper}
        onSwiper={(swiperInstance) => {
          sliderRef.current = swiperInstance;
        }}
      >
        {nearbyResorts.map((resort) => (
          <SwiperSlide
            className={classNames(styles.height_auto, styles.slide)}
          >
            <Link href={Routes.resortTripPlanningOverview({ ...resort, region: resort.region.slug })}>
              <div className="column">
                <div className={styles.row}>
                  <ImageComponent
                    alt={resort.imageCaption}
                    src={resort.image}
                    className={styles.image}
                  />
                </div>
                <div className={classNames(styles.row, styles.text_container)}>
                  <div className={styles.resort_name}>{resort.title}</div>
                  <div>
                    <button className={styles.link} type="button">
                      VIEW
                    </button>
                  </div>
                </div>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};
